// @flow
import { CLEAR_SETTINGS, SET_SETTINGS } from '../actions/settings';

import type { Action } from './types';

const initialState = {
    playlistsFirst: false,
    expandedByDefault: false,
    syncDownloads: false,
    preferredLanguage: "en",
    preferredFileFormat: "pdf",
    exactSearch: true
};

//Reducer that manages a playlist
export default function settings( state = initialState, action: Action ) {
    switch ( action.type ) {
        case SET_SETTINGS:
            const { settings } = action;
            return { ...state, ...settings };
        case CLEAR_SETTINGS:
            return initialState;
        default:
            return state;
    }
}